import Image from "@/components/Image";
import { useRef } from "react";

const videoMap = {
  "1": `${process.env.NEXT_PUBLIC_CDN_URL}/_next/public/3.mp4`,
  "2": `${process.env.NEXT_PUBLIC_CDN_URL}/_next/public/2.mp4`,
  "3": `${process.env.NEXT_PUBLIC_CDN_URL}/_next/public/1.mp4`,
};

const Modal = ({
  type,
  onClose,
  show,
}: {
  type: string;
  onClose: () => void;
  show: boolean;
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const onCloseVideo = () => {
    // 关闭视频播放
    videoRef.current?.pause();
    onClose();
  };

  return (
    <div
      className={`fixed ${show ? "top-0" : "top-10000"} left-0 z-[1000] w-full h-full bg-[rgba(0,0,0,0.6)]  flex justify-center items-center`}
    >
      <video
        ref={videoRef}
        preload="metadata"
        src={videoMap[type as keyof typeof videoMap]}
        className="max-w-[80%] max-h-[80%]"
        controls
      />
      <div className="absolute left-1/2 -translate-x-1/2 bottom-[10px] cursor-pointer bg-white rounded-full">
        <Image
          onClick={onCloseVideo}
          src="/close.png"
          alt="01"
          width={60}
          height={60}
          className="mx-auto"
        />
      </div>
    </div>
  );
};

export default Modal;
